
export default function WhyChooseUs() {
  const advantages = [
    {
      icon: 'ri-team-line',
      title: 'Équipe Professionnelle',
      description: 'Personnel formé, expérimenté et assuré pour tous nos services'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Flexibilité Horaires',
      description: 'Interventions adaptées à votre emploi du temps, 7j/7'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Produits Écologiques',
      description: 'Utilisation de produits respectueux de l\'environnement'
    },
    {
      icon: 'ri-price-tag-3-line',
      title: 'Tarifs Transparents',
      description: 'Devis gratuit et tarification claire sans surprise'
    },
    {
      icon: 'ri-customer-service-line',
      title: 'Service Client',
      description: 'Support réactif et suivi personnalisé de vos demandes'
    },
    {
      icon: 'ri-medal-line',
      title: 'Satisfaction Garantie',
      description: 'Reprise gratuite si le résultat ne vous convient pas'
    }
  ];

  const stats = [
    { number: '500+', label: 'Clients Satisfaits' },
    { number: '10+', label: 'Années d\'Expérience' },
    { number: '98%', label: 'Taux de Satisfaction' },
    { number: '24h', label: 'Délai d\'Intervention' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-blue-50 to-green-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Pourquoi Choisir NetPro Services ?
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Notre engagement : vous offrir un service de qualité supérieure 
            avec la fiabilité que vous méritez
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {advantages.map((advantage, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                <i className={`${advantage.icon} text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-3">
                {advantage.title}
              </h3>
              <p className="text-gray-600">
                {advantage.description}
              </p>
            </div>
          ))}
        </div>

        {/* Statistiques */}
        <div className="bg-white rounded-2xl p-8 shadow-sm">
          <h3 className="text-2xl font-bold text-center text-gray-900 mb-8">
            Nos Résultats Parlent d'Eux-Mêmes
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            {stats.map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-3xl md:text-4xl font-bold text-blue-600 mb-2">
                  {stat.number}
                </div>
                <div className="text-gray-600 font-medium">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Témoignages */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-center text-gray-900 mb-8">
            Ce Que Disent Nos Clients
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <div className="flex items-center mb-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20businesswoman%20headshot%20portrait%2C%20friendly%20smile%2C%20modern%20office%20background%2C%20clean%20professional%20appearance%2C%20natural%20lighting%2C%20corporate%20style%20photography&width=60&height=60&seq=testimonial-1&orientation=squarish"
                  alt="Marie Dubois"
                  className="w-12 h-12 rounded-full object-cover mr-3"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">Marie Dubois</h4>
                  <p className="text-sm text-gray-600">Particulier</p>
                </div>
              </div>
              <div className="flex mb-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              <p className="text-gray-700">
                "Service impeccable ! L'équipe est très professionnelle et le résultat 
                dépasse mes attentes. Je recommande vivement."
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <div className="flex items-center mb-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20businessman%20headshot%20portrait%2C%20confident%20smile%2C%20business%20suit%2C%20modern%20office%20environment%2C%20corporate%20executive%20style%2C%20professional%20lighting&width=60&height=60&seq=testimonial-2&orientation=squarish"
                  alt="Pierre Martin"
                  className="w-12 h-12 rounded-full object-cover mr-3"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">Pierre Martin</h4>
                  <p className="text-sm text-gray-600">Directeur d'entreprise</p>
                </div>
              </div>
              <div className="flex mb-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              <p className="text-gray-700">
                "Partenaire fiable pour l'entretien de nos bureaux. Ponctualité 
                et qualité au rendez-vous depuis 3 ans."
              </p>
            </div>
            
            <div className="bg-white rounded-xl p-6 shadow-sm">
              <div className="flex items-center mb-4">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20woman%20headshot%20portrait%2C%20warm%20smile%2C%20casual%20business%20attire%2C%20modern%20office%20background%2C%20approachable%20appearance%2C%20natural%20professional%20lighting&width=60&height=60&seq=testimonial-3&orientation=squarish"
                  alt="Sophie Lefebvre"
                  className="w-12 h-12 rounded-full object-cover mr-3"
                />
                <div>
                  <h4 className="font-semibold text-gray-900">Sophie Lefebvre</h4>
                  <p className="text-sm text-gray-600">Particulier</p>
                </div>
              </div>
              <div className="flex mb-3">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400"></i>
                ))}
              </div>
              <p className="text-gray-700">
                "Le service de courses est fantastique ! Ils connaissent mes 
                préférences et livrent toujours à l'heure."
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}